const data = {
  especificacao: [
    {
      id: 1,
      titulo: 'Nintendo Switch 32GB, 1x Joycon, Neon Azul/Vermelho',
      descricao:
        'Console Nintendo Switch O console que lhe permite jogar os jogos que quiser, onde e como quiser. witcnde e como quiser. witcnde e como quiser. witcnde e como quiser. witch',
      imagem: 'https://i.postimg.cc/2yLks5wn/1.png',
      preco: 2150.91,
    },
    {
      id: 2,
      titulo: 'Controle Dualshock 4 - PlayStation 4 - Preto',
      descricao:
        'Sua experiência com os jogos do Playstation, com certeza, não são as mesmas depois de experimentar o Dualshock 4. O toque, o formato anatômico, a sensibilidade dos controles analógicos e os botões com gatilho oferecem aos jogadores muito conforto',
      imagem: 'https://i.postimg.cc/Y9hLSMRC/10.png',
      preco: 300.00,
    },
    {
      id: 3,
      titulo: 'Controle Com textura PlayStation 4 - Preto',
      descricao:
        'Controle para Ps4 Sem Fio Recarregável Joystick Preto. ocê pode passar horas jogando com total conforto. Conta com botões macios, gatilhos rápidos, touchpad funcional e analógicos firmes e precisos, além de contar também com função de vibração para uma melhor experiência na hora do jogo. ',
      imagem: 'https://i.postimg.cc/V6prrpZB/11.png',
      preco: 250.00,
    },
    {
      id: 4,
      titulo: 'Sony PlayStation 4 Slim 1TB Mega Pack:',
      descricao:
        'Com seu console PlayStation 4 você terá entretenimento garantido todos os dias. Sua tecnologia foi criada para colocar novos desafios para jogadores novatos e especialistas.',
      imagem: 'https://i.postimg.cc/Xq5ZwLTM/12.png',
      preco: 1968.99,
    },
    {
      id: 5,
      titulo: 'Sony PlayStation 4 Slim 1TB Mega Pack + 3 Games grátis',
      descricao:
        'O PS4 é centrado nos jogadores, possibilitando que eles joguem quando, onde e como quiserem, possibilita que os maiores desenvolvedores de jogos do mundo deem asas à sua criatividade e transcendam os limites do ato de jogar por meio de um sistema que é ajustado especialmente para suas necessidades.',
      imagem: 'https://i.postimg.cc/59QFd9jP/13.png',
      preco: 2232.90,
    },
    {
      id: 6,
      titulo:
        'Sony PlayStation 4 Slim 1TB Mega Pack: + 1 Games grátis e + um controle para jogar com a familia',
      descricao:
        'Centrado no jogador, inspirado no desenvolvedor- o ps4 permite que os melhores desenvolvedores de jogos do mundo liberem sua criatividade e estendam os limites do jogo por meio de uma plataforma que está sintonizada especificamente com suas necessidades.',
      imagem: 'https://i.postimg.cc/3JM0KMv3/14.png',
      preco: 2124.50,
    },
    {
      id: 7,
      titulo: 'PlayStation 5 2022 Nova Geração 825GB 1 Controle - Branco Sony',
      descricao:
        'novo PlayStation 5 diz tudo sobre o console lançado em 2020. Desfrute do carregamento extremamente rápido com o SSD de 825GB de altíssima velocidade, uma imersão mais profunda com suporte a feedback tátil, gatilhos adaptáveis e áudio 3D, além de uma geração inédita de jogos incríveis para PlayStation.',
      imagem: 'https://i.postimg.cc/5NwYyPBL/16.png',
      preco: 4799.65,
    },
    {
      id: 8,
      titulo: 'Controle Dualsense PlayStation 5 PS5',
      descricao:
        'O controle sem fio branco DualSense também inclui um microfone integrado e botão de criação, tudo em um design icônico e confortável. O feedback háptico, que adiciona uma variedade de sensações poderosas que sentirá quando jogar,',
      imagem: 'https://i.postimg.cc/T30KqpHP/17.png',
      preco: 419.90,
    },
    {
      id: 9,
      titulo:
        'Console PlayStation 5 Controle Dual Sense PS5 Branco Preto - Sony',
      descricao:
        'PlayStation 5 Domine o poder de uma CPU e GPU personalizadas e o SSD com E/S integradas que redefinem as regras do que o console PlayStation 5 pode fazer. Maximize suas sessões de jogo com tempos de carregamento praticamente instantâneos para jogos instalados. A integração personalizada dos sistemas de console PS5 permite que os criadores extraiam dados do SSD tão rápido que eles podem desenvolver jogos de formas que antes seriam impossíveis. ',
      imagem: 'https://i.postimg.cc/xddcsnW3/18.png',
      preco: 5304.80,
    },
    {
      id: 10,
      titulo: 'Controle PS5 Dualsense Branco Original',
      descricao:
        'A integração personalizada dos sistemas de console PS5 permite que os criadores extraiam dados do SSD tão rápido que eles podem desenvolver jogos de formas que antes seriam impossíveis.',
      imagem: 'https://i.postimg.cc/DZJmT5fW/19.png',
      preco: 420.56,
    },
    {
      id: 11,
      titulo: 'Console Switch Tela Oled 7 polegadas 64gb',
      descricao:
        'O novo sistema Switch foi projetado para apresentar uma tela OLED vibrante de 7 polegadas para cores vivas e contraste nítido, onde quer que você esteja a jogar, dispõe de amplo suporte ajustável para desfrutar de ângulo adequado, bem como um dock com porta LAN com fio e 64gb de capacidade de armazenamento interno, sendo uma parte reservada para uso pelo sistema e a outra para salvar seus jogos favoritos, além de áudio aprimor',
      imagem: 'https://i.postimg.cc/fk4zDh2p/2.png',
      preco: 2304.76,
    },
    {
      id: 12,
      titulo: 'Controle PS5 Dualsense Preto Original',
      descricao:
        'Conta com botões macios, gatilhos rápidos, touchpad funcional e analógicos firmes e precisos, além de contar também com função de vibração para uma melhor experiência na hora do jogo.',
      imagem: 'https://i.postimg.cc/8Cns9xGQ/20.png',
      preco: 450.24,
    },
    {
      id: 13,
      titulo: 'PlayStation 5 PRO Controle Dual Sense PS5 Preto',
      descricao:
        'Com uma TV HDR, os jogos compatíveis do PS5 exibem uma variedade de cores inacreditavelmente vibrantes e realistas. Saída em 8K Os consoles PS5 oferecem suporte à saída 8K, para que você possa jogar na sua tela com resolução de 4320p.',
      imagem: 'https://i.postimg.cc/ydMxY9WL/21.png',
      preco: 4235.64,
    },
    {
      id: 14,
      titulo: 'Xbox Series X 2Tb branco',
      descricao:
        'Apresentamos o Xbox Series X, nosso console mais rápido e poderoso de todos os tempos. Jogue milhares de títulos de quatro gerações de consoles- todos os jogos têm melhor aparência e são melhor executados no Xbox Series X. No coração do Series X está a Xbox Velocity Architecture, que combina um SSD personalizado e software integrado para diminuir significativamente os tempos de carregamento dentro e fora do jogo. Troque simultaneamente entre vários jogos em um instante com o Quick Resume.',
      imagem: 'https://i.postimg.cc/tCHJKhKT/22.png',
      preco: 4476.49,
    },
    {
      id: 15,
      titulo: 'Xbox Series S 2Tb Preto',
      descricao:
        'Jogue milhares de títulos de quatro gerações de consoles- todos os jogos têm melhor aparência e são melhor executados no Xbox Series X. No coração do Series X está a Xbox Velocity Architecture, que combina um SSD personalizado e software integrado para diminuir significativamente os tempos de carregamento dentro e fora do jogo.',
      imagem: 'https://i.postimg.cc/3N2RyRvY/23.png',
      preco: 4996.39,
    },
    {
      id: 16,
      titulo: 'Controle para Xbox Series X Xbox',
      descricao:
        'Experimente o design modernizado do Controle Sem Fio para Xbx Series X/S Robot White na cor branca, com superfícies esculpidas e geometria refinada para maior conforto durante o jogo. Fique no alvo com o grip texturizado e um direcional híbrido. Capture e compartilhe conteúdo perfeitamente com um botão Compartilhar dedicado. Conecte-se, jogue e alterne rapidamente entre dispositivos',
      imagem: 'https://i.postimg.cc/T2bhNkHF/24.png',
      preco: 353.87,
    },
    {
      id: 17,
      titulo: 'Xbox Series X Halo Infinite - Edição Epecial',
      descricao:
        'Xbox Series X Edição Especial, Comemore o 20º aniversário de Halo e enfrente o inimigo mais implacável que já passou pelo Master com a edição especial Xbox Series X Halo Infinite.',
      imagem: 'https://i.postimg.cc/8PBcN7Gb/25.png',
      preco: 6834.83,
    },
    {
      id: 18,
      titulo: 'Controle para Xbox Series X Xbox Pretp',
      descricao:
        'com superfícies esculpidas e geometria refinada para maior conforto durante o jogo. Fique no alvo com o grip texturizado e um direcional híbrido. Capture e compartilhe conteúdo perfeitamente com um botão Compartilhar dedicado. Conecte-se, jogue e alterne rapidamente entre dispositivos',
      imagem: 'https://i.postimg.cc/YCr99tqB/26.png',
      preco: 353.87,
    },
    {
      id: 19,
      titulo:
        'Console New Nintendo Switch - Azul Neon e Vermelho Neon (versão nacional)',
      descricao:
        'Modelo com bateria estendida; duração varia de acordo com os jogos ou aplicações utilizados; com The Legend of Zelda: Breath of the Wild, por exemplo, a bateria dura aproximadamente 5, 5 horas',
      imagem: 'https://i.postimg.cc/GhYYY3CB/3.png',
      preco: 2354.90,
    },
    {
      id: 20,
      titulo: 'Suporte Para Nintendo Switch',
      descricao:
        'Dobrável para portabilidade, Angulo ajustável Apertos emborrachados para estabilidade, Oficialmente licenciado pela Nintendo',
      imagem: 'https://i.postimg.cc/Gp3sZksY/4.png',
      preco: 123.28,
    },
    {
      id: 21,
      titulo: 'Videogame Playstation 3 Super Slim',
      descricao:
        '1 Console Super Slim 250Gb Mostruário de loja (estado de novo)NÃO ACOMPANHA A CAIXA ORIGINAL1 Cabo HDMI1 Cabo Energia1 Cabo AV1 Controle Dual Shock Sony1 Jogo de aleatório (mandamos o disponível no momento da postagem,',
      imagem: 'https://i.postimg.cc/9XsZrRv5/5.png',
      preco: 1493.30,
    },
    {
      id: 22,
      titulo: 'Videogame Playstation 3 Super Slim + 45 games',
      descricao:
        'Com seu console PlayStation 3 você terá entretenimento garantido todos os dias. Sua tecnologia foi criada para colocar novos desafios para jogadores novatos e especialistas.',
      imagem: 'https://i.postimg.cc/7Zn2sBbw/6.png',
      preco: 1983.80,
    },
    {
      id: 23,
      titulo: 'controle ps3 original - Controle Para playstation 3 - sony dual',
      descricao:
        'O sistema SIXAXIS, responde precisamente a cada movimento que você fizer em 6 eixos proporcionando uma sensação incrível a cada jogada. Você pode jogar com os amigos e quem mais desejar de diversos cantos da casa. O controle DualShock pode ser carregado facilmente através do cabo USB. O Playstation 3 suporta até sete controles sem fio simultaneamente, assim seus jogos multiplayer serão muito mais divertidos.',
      imagem: 'https://i.postimg.cc/gcx3zqtH/7.png',
      preco: 146.43,
    },
    {
      id: 24,
      titulo: 'controle ps3 original com fio 2 metro',
      descricao:
        'Você pode jogar com os amigos e quem mais desejar de diversos cantos da casa. O controle DualShock pode ser carregado facilmente através do cabo USB. O Playstation 3 suporta até sete controles sem fio simultaneamente, assim seus jogos multiplayer serão muito mais divertidos.',
      imagem: 'https://i.postimg.cc/qvTKGfJ1/8.png',
      preco: 120.67,
    },
    {
      id: 25,
      titulo: 'Controle Sony Dualshock 4 PS4, Sem Fio, Preto',
      descricao:
        'Revolucionário, intuitivo e preciso: o controle sem fio DualShock 4 para o sistema PlayStation 4 define esta geração de jogos, combinando recursos revolucionários e conforto com controles precisos e intuitivos',
      imagem: 'https://i.postimg.cc/yNfSBkFG/9.png',
      preco: 432.37,
    },
  ],
  bannerHome: [
    {
      id: 0,
      titulo: 'Console PlayStation 5 Controle Dual Sense Branco Preto',
      descricao: 'A integração personalizada dos sistemas de console PS5 permite que os criadores extraiam dados do SSD tão rápido que eles podem desenvolver jogos de formas que antes seriam impossíveis.',
      imagem: 'https://i.postimg.cc/T2tzmYsN/PS5.png',
      preco: 3999.99,
    }
  ]
}

export default data
